export default class RuleScriptFilter {
  name: string;

  status: string;

  constructor(obj: any = {}) {
    this.name = obj.name || '';
    this.status = obj.status || '';
  }

  public static of(obj: any = {}): RuleScriptFilter {
    return new RuleScriptFilter(obj);
  }
}
